import * as actionTypes from "Redux/Actions/actionTypes";

const initialState = {
  success: "",
  error: "",
};

const VerificationCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.VERIFICATIONCODE_RESPONSE:
      return {
        ...state,
        success: action.success,
        error: "",
      };
    case actionTypes.VERIFICATIONCODE_ERROR:
      return {
        ...state,
        error: action.error,
        success: "",
      };
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
};

export default VerificationCodeReducer;
